export default __webpack_public_path__ + "static/media/addAnnouncementWhite.f8855bc3.svg";